import { MED_SKU } from "src/utils/medEligibility";

function getProductPairForGlpMedPreference(
  glpAnswer: string
): readonly [MED_SKU, MED_SKU] | undefined {
  switch (glpAnswer) {
    case "tirzepatide":
      return [MED_SKU.COMPOUNDED_TIRZEPATIDE, MED_SKU.BRANDED_ZEPBOUND_VIAL];
    case "semaglutide":
      return [MED_SKU.COMPOUNDED, MED_SKU.BRANDED];
    case "wegovypill":
      return [MED_SKU.BRANDED_WEGOVY_PILL, MED_SKU.COMPOUNDED_MICRODOSE];
    default:
      return undefined;
  }
}

export function getRecommendedMedSkuFromGlpMedPreference(
  eligibleProducts: MED_SKU[],
  glpAnswer: string | undefined
): MED_SKU | undefined {
  if (!glpAnswer) {
    return undefined;
  }

  const pair = getProductPairForGlpMedPreference(glpAnswer);
  if (!pair) {
    return undefined;
  }

  const [first, second] = pair;
  const firstEligible = eligibleProducts.includes(first);
  const secondEligible = eligibleProducts.includes(second);

  if (firstEligible && !secondEligible) {
    return first;
  }
  if (!firstEligible && secondEligible) {
    return second;
  }
  return undefined;
}
